<template>
    <div class="accordion accordion-flush border-bottom p-0" id="accordionFAQ">
        <!--fixa template för loopen-->
  
        <div class="accordion-item" v-for="q, i in questions" :key="i" :id="q.id" style="scroll-margin-top: 30px;">
          <h2 class="accordion-header" :id="'heading' + q.id">
            <div class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              :data-bs-target="'#collapse-' + q.id" aria-expanded="false" :aria-controls="'collapse-' + q.id"
               v-html="q.title.rendered">
            </div>
          </h2>
          <div :id="'collapse-' + q.id" class="accordion-collapse collapse"
            :class="{ 'show': currentQ ? currentQ.id == q.id : '' }" :aria-labelledby="'heading' + q.id"
            data-bs-parent="#questionAccordion">
            <div class="accordion-body"><span v-html="q.content.rendered"></span>
              <a v-if="q.acf.call_to_action.length != 0" class="btn btn-primary mb-2" target="_blank" :href="q.acf.call_to_action_link">{{q.acf.call_to_action}}</a>
  
  
              <Transition name="slide-main">
                    <div :id="'vote-' + q.id" class="pt-3 border-top mt-3"><strong class="d-block mb-3">Fick du svar på din
                        fråga?</strong>
                      <div class="d-flex align-items-start justify-content-start">
  
                        <div>
                          <a @click="voteForm(q.id, 'like')" class="btn" title="Ja, jag fick svar" aria-label="Ja, jag fick svar">
                            <i class="fa-regular fa-thumbs-up fa-lg"></i>
                          </a>
                        </div>
                        
  
                        <div>
                          <a @click="voteForm(q.id, 'unlike')" class="btn" title="Nej, jag fick inget bra svar" aria-label="Nej, jag fick inget bra svar">
                            <i class="fa-regular fa-thumbs-down fa-flip-horizontal fa-lg"></i>
                          </a>
                        </div>
  
                      </div>
                    </div>
                  </Transition>
                  <Transition name="slide-sub">
                    <div :id="'voted-' + q.id" class="d-none"> <strong class='d-block p-3 bg-light text-center'>Tack för din
                        feedback!</strong></div>
                    </Transition>
  
  
            </div>
          </div>
        </div>
      </div>
</template>
<script>


export default {
props: {questions:{type: Array}, currentQ: {type: Object}, voteForm: {type: Function}} ,   
mounted(){
  console.log(this.questions)
}
}
</script>